// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddModuleConfirmation_containers {
  overflow: hidden;
  height: 100vh;
}
.AddModuleConfirmation_containers .AddModuleConfirmation_container {
  width: 100%;
  display: flex;
  overflow: hidden;
}
.AddModuleConfirmation_containers .sidebar {
  width: 20%;
  background: #dde7f5;
}
.AddModuleConfirmation_containers .AddModuleConfirmationcontent {
  width: 100%;
  background: #ffffff;
  overflow-y: scroll;
  overflow-x: hidden;
  height: 81vh;
}
.AddModuleConfirmation_containers .input-wrapper {
  position: relative;
}
.AddModuleConfirmation_containers label {
  position: absolute;
  top: 0.2ex;
  z-index: 1;
  left: 2em;
  background-color: white;
  padding: 0 5px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #0c3688;
}
.AddModuleConfirmation_containers .AddModuleConfirmation_panel .panel-all {
  display: flex;
  width: 95%;
  margin: 1rem;
  font-family: Nunito;
  font-weight: 600;
  font-size: 20px;
  color: rgb(16, 19, 46);
}
.AddModuleConfirmation_containers .AddModuleConfirmation_panel .panel-all .AddModuleConfirmation_Close {
  width: 15%;
  height: 40px;
  background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);
  border-radius: 8px 8px 8px 8px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  font-size: 1rem;
  color: #FFFFFF;
  border: none;
  margin-left: 64%;
}
.AddModuleConfirmation_containers .header_border {
  background: #C0C8DA;
  height: 2.4rem;
  border: 1px solid #C0C8DA;
  font-size: 12px;
  font-weight: 500;
  font-family: "Nunito";
  color: rgb(45, 45, 45);
  display: flex;
  justify-content: start;
  align-items: center;
}
.AddModuleConfirmation_containers .header_border > img {
  margin: 0.9rem 1rem;
}
.AddModuleConfirmation_containers .header_border > span {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  align-items: center;
  letter-spacing: -0.28px;
  margin: 0.7rem 1rem;
}
.AddModuleConfirmation_containers .hero-section {
  width: 100%;
  border-radius: 6px;
  background: #ffffff;
}
.AddModuleConfirmation_containers .hero-section .title-input {
  margin-left: 0.6rem;
  width: 100%;
}
.AddModuleConfirmation_containers .hero-section .text-field {
  border: 1px solid gray;
  border-radius: 0px;
  position: relative;
  width: 92%;
  margin: 10px;
  line-height: 6ex;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: #10132E;
  padding: 0rem 0.5rem;
  height: 2.5rem;
}
.AddModuleConfirmation_containers .hero-section .input-wrapper {
  position: relative;
}
.AddModuleConfirmation_containers .hero-section .panel-text {
  font-size: 14px;
  font-family: "Nunito";
  font-weight: 400;
  color: rgb(12, 54, 136);
  height: 2rem;
  margin: 10px;
  padding: 0rem 0.6rem;
}
.AddModuleConfirmation_containers .hero-section .panel-text .Addmodelcreation_create {
  width: 15%;
  height: 40px;
  background: #0C3688;
  box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);
  border-radius: 8px 8px 8px 8px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  font-size: 1rem;
  color: #FFFFFF;
  border: none;
  margin-left: 2%;
}
.AddModuleConfirmation_containers .hero-section .confirmation-content-box {
  width: 98%;
  background-color: #FFFFFF;
  border: 1px solid rgb(174, 180, 193);
  margin: 2rem 1rem 0rem 1rem;
  border-radius: 8px;
}
.AddModuleConfirmation_containers .hero-section .confirmation-content-box .content-heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 98%;
  font-size: 20px;
  font-weight: 600;
  font-family: "Nunito";
  color: rgb(12, 54, 136);
  padding: 1rem 1rem 0rem 1rem;
}
.AddModuleConfirmation_containers .hero-section .confirmation-content-box .content-heading .content-edit {
  color: rgb(12, 54, 136);
  font-size: 14px;
  font-weight: 700;
  font-family: "Nunito";
  text-decoration: underline;
}
.AddModuleConfirmation_containers .hero-section .confirmation-content-box .confirmation-date {
  width: 98%;
  padding: 1rem 1rem 0rem 1rem;
}
.AddModuleConfirmation_containers .hero-section .confirmation-content-box .confirmation-date .panel-date {
  font-size: 16px;
  font-weight: 700;
  font-family: "Nunito";
  color: #000000;
}
.AddModuleConfirmation_containers .hero-section .confirmation-content-box .confirmation-date .panel-dateHead {
  font-size: 14px;
  font-weight: 700;
  font-family: "Nunito";
  color: #6C7EA1;
  margin-right: 61%;
}
.AddModuleConfirmation_containers .hero-section .confirmation-content-box hr {
  border: 1px solid #A3AEC4;
  width: 96%;
  margin: 1rem;
}
.AddModuleConfirmation_containers .hero-section .confirmation-content-box .main-content {
  background: rgb(229, 240, 255);
  margin: 1rem;
  padding: 0.5rem;
  display: flex;
  width: 96%;
  border-radius: 8px;
  height: 23%;
}
.AddModuleConfirmation_containers .hero-section .confirmation-content-box .main-content .main-image {
  width: 16%;
}
.AddModuleConfirmation_containers .hero-section .confirmation-content-box .main-content .text-content {
  width: 70%;
}
.AddModuleConfirmation_containers .hero-section .confirmation-content-box .main-content .text-content .text-content1 {
  font-size: 14px;
  font-weight: 500;
  font-family: Poppins;
  color: rgb(16, 19, 46);
}
.AddModuleConfirmation_containers .hero-section .confirmation-content-box .main-content .text-content .text-content2 {
  font-size: 12px;
  font-weight: 500;
  font-family: Poppins;
  color: rgb(124, 135, 161);
}

::-webkit-scrollbar {
  width: 0.875em;
}

::-webkit-scrollbar-thumb {
  background: rgb(163, 174, 196);
  border-radius: 0em;
}

::-webkit-scrollbar-thumb:hover {
  background-color: rgb(163, 174, 196);
}`, "",{"version":3,"sources":["webpack://./src/pages/AddEditModule/AddModuleConfirmation/Addmoduleconfirmation.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,aAAA;AACJ;AACI;EACI,WAAA;EACA,aAAA;EACA,gBAAA;AACR;AAGI;EACI,UAAA;EACA,mBAAA;AADR;AAII;EACI,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;AAFR;AAMI;EACI,kBAAA;AAJR;AAOI;EACI,kBAAA;EACA,UAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AALR;AASQ;EACI,aAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;AAPZ;AASY;EACI,UAAA;EACA,YAAA;EACA,mEAAA;EACA,8BAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;AAPhB;AAaI;EACI,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAXR;AAeI;EACI,mBAAA;AAbR;AAgBI;EAEI,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAfR;AAkBI;EACI,WAAA;EACA,kBAAA;EACA,mBAAA;AAhBR;AAkBQ;EACI,mBAAA;EACA,WAAA;AAhBZ;AAmBQ;EACI,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;EACA,cAAA;AAjBZ;AAoBQ;EACI,kBAAA;AAlBZ;AAqBQ;EACI,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,oBAAA;AAnBZ;AAqBY;EACI,UAAA;EACA,YAAA;EACA,mBAAA;EACA,8CAAA;EACA,8BAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;AAnBhB;AAuBQ;EACI,UAAA;EACA,yBAAA;EACA,oCAAA;EACA,2BAAA;EACA,kBAAA;AArBZ;AAuBY;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,uBAAA;EACA,4BAAA;AArBhB;AAuBgB;EACI,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,0BAAA;AArBpB;AA0BY;EACI,UAAA;EACA,4BAAA;AAxBhB;AA0BgB;EACI,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;AAxBpB;AA6BgB;EACI,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;EACA,iBAAA;AA3BpB;AA+BY;EACI,yBAAA;EACA,UAAA;EACA,YAAA;AA7BhB;AAgCY;EACI,8BAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;AA9BhB;AAgCgB;EACI,UAAA;AA9BpB;AAiCgB;EACI,UAAA;AA/BpB;AAiCoB;EACI,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;AA/BxB;AAmCoB;EACI,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,yBAAA;AAjCxB;;AAiDA;EACI,cAAA;AA9CJ;;AAiDA;EACI,8BAAA;EACA,kBAAA;AA9CJ;;AAiDA;EACI,oCAAA;AA9CJ","sourcesContent":[".AddModuleConfirmation_containers {\n    overflow: hidden;\n    height: 100vh;\n\n    .AddModuleConfirmation_container {\n        width: 100%;\n        display: flex;\n        overflow: hidden;\n    }\n\n\n    .sidebar {\n        width: 20%;\n        background: #dde7f5;\n    }\n\n    .AddModuleConfirmationcontent {\n        width: 100%;\n        background: #ffffff;\n        overflow-y: scroll;\n        overflow-x: hidden;\n        height: 81vh;\n\n    }\n\n    .input-wrapper {\n        position: relative;\n    }\n\n    label {\n        position: absolute;\n        top: 0.2ex;\n        z-index: 1;\n        left: 2em;\n        background-color: white;\n        padding: 0 5px;\n        font-family: \"Nunito\";\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        color: #0c3688;\n    }\n\n    .AddModuleConfirmation_panel {\n        .panel-all {\n            display: flex;\n            width: 95%;\n            margin: 1rem;\n            font-family: Nunito;\n            font-weight: 600;\n            font-size: 20px;\n            color: rgba(16, 19, 46, 1);\n\n            .AddModuleConfirmation_Close {\n                width: 15%;\n                height: 40px;\n                background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);\n                border-radius: 8px 8px 8px 8px;\n                font-family: 'Poppins';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 1rem;\n                color: #FFFFFF;\n                border: none;\n                margin-left: 64%;\n\n            }\n        }\n    }\n\n    .header_border {\n        background: #C0C8DA;\n        height: 2.4rem;\n        border: 1px solid #C0C8DA;\n        font-size: 12px;\n        font-weight: 500;\n        font-family: \"Nunito\";\n        color: rgba(45, 45, 45, 1);\n        display: flex;\n        justify-content: start;\n        align-items: center;\n\n    }\n\n    .header_border>img {\n        margin: 0.9rem 1rem;\n    }\n\n    .header_border>span {\n\n        font-family: 'Nunito';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 12px;\n        line-height: 16px;\n        display: flex;\n        align-items: center;\n        letter-spacing: -0.28px;\n        margin: 0.7rem 1rem;\n    }\n\n    .hero-section {\n        width: 100%;\n        border-radius: 6px;\n        background: #ffffff;\n\n        .title-input {\n            margin-left: 0.6rem;\n            width: 100%;\n        }\n\n        .text-field {\n            border: 1px solid gray;\n            border-radius: 0px;\n            position: relative;\n            width: 92%;\n            margin: 10px;\n            line-height: 6ex;\n            font-family: \"Nunito\";\n            font-style: normal;\n            font-weight: 600;\n            font-size: 16px;\n            color: #10132E;\n            padding: 0rem 0.5rem;\n            height: 2.5rem;\n        }\n\n        .input-wrapper {\n            position: relative;\n        }\n\n        .panel-text {\n            font-size: 14px;\n            font-family: \"Nunito\";\n            font-weight: 400;\n            color: rgb(12, 54, 136);\n            height: 2rem;\n            margin: 10px;\n            padding: 0rem 0.6rem;\n\n            .Addmodelcreation_create {\n                width: 15%;\n                height: 40px;\n                background: #0C3688;\n                box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);\n                border-radius: 8px 8px 8px 8px;\n                font-family: 'Poppins';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 1rem;\n                color: #FFFFFF;\n                border: none;\n                margin-left: 2%;\n            }\n        }\n\n        .confirmation-content-box {\n            width: 98%;\n            background-color: #FFFFFF;\n            border: 1px solid rgb(174, 180, 193);\n            margin: 2rem 1rem 0rem 1rem;\n            border-radius: 8px;\n\n            .content-heading {\n                display: flex;\n                justify-content: space-between;\n                align-items: center;\n                width: 98%;\n                font-size: 20px;\n                font-weight: 600;\n                font-family: \"Nunito\";\n                color: rgba(12, 54, 136, 1);\n                padding: 1rem 1rem 0rem 1rem;\n\n                .content-edit {\n                    color: rgba(12, 54, 136, 1);\n                    font-size: 14px;\n                    font-weight: 700;\n                    font-family: \"Nunito\";\n                    text-decoration: underline;\n\n                }\n            }\n\n            .confirmation-date {\n                width: 98%;\n                padding: 1rem 1rem 0rem 1rem;\n\n                .panel-date {\n                    font-size: 16px;\n                    font-weight: 700;\n                    font-family: \"Nunito\";\n                    color: #000000;\n\n\n                }\n\n                .panel-dateHead {\n                    font-size: 14px;\n                    font-weight: 700;\n                    font-family: \"Nunito\";\n                    color: #6C7EA1;\n                    margin-right: 61%;\n                }\n            }\n\n            hr {\n                border: 1px solid #A3AEC4;\n                width: 96%;\n                margin: 1rem;\n            }\n\n            .main-content {\n                background: rgb(229, 240, 255);\n                margin: 1rem;\n                padding: 0.5rem;\n                display: flex;\n                width: 96%;\n                border-radius: 8px;\n                height: 23%;\n\n                .main-image {\n                    width: 16%;\n                }\n\n                .text-content {\n                    width: 70%;\n\n                    .text-content1 {\n                        font-size: 14px;\n                        font-weight: 500;\n                        font-family: Poppins;\n                        color: rgba(16, 19, 46, 1);\n\n                    }\n\n                    .text-content2 {\n                        font-size: 12px;\n                        font-weight: 500;\n                        font-family: Poppins;\n                        color: rgba(124, 135, 161, 1);\n\n                    }\n\n\n\n                }\n            }\n\n        }\n\n\n    }\n\n}\n\n::-webkit-scrollbar {\n    width: 0.875em;\n}\n\n::-webkit-scrollbar-thumb {\n    background: rgba(163, 174, 196, 1);\n    border-radius: 0em;\n}\n\n::-webkit-scrollbar-thumb:hover {\n    background-color: rgba(163, 174, 196, 1);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
